import { render } from "./GridLayout.vue?vue&type=template&id=3c5d7dd0"
import script from "./GridLayout.vue?vue&type=script&lang=js"
export * from "./GridLayout.vue?vue&type=script&lang=js"

import "./GridLayout.vue?vue&type=style&index=0&id=3c5d7dd0&lang=css"

import exportComponent from "C:\\Users\\Daniil\\myProjects\\vueGridLayout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__